import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { grey } = colors

const EmptyCircle = (props: Icon) => {
    const { color = grey, size = 24, className = 'emptycircle' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-1.667 0a8.333 8.333 0 1 0-16.667 0 8.333 8.333 0 0 0 16.667 0z"
                fill={color}
            />
        </svg>
    )
}

export { EmptyCircle }
